// /src/components/LoadingSpinner.jsx


const LoadingSpinner = () => (
    <div className="spinner-container">
      <div className="loader"></div>
    </div>
  );

export default LoadingSpinner;
